import { Injectable } from '@angular/core';
import { CompatibilityResultData } from '../model/compatibility-result-data';
import * as Translations from '../../assets/cat_resources/AllTranslationsAsJavascriptObject.json';
import { BrowserPlatformService } from './browser-platform.service';
import { environment } from '../../environments/environment';
// Force TypeScript to re-evaluate JSON imports

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  public STARKEY_SUB_DOMAIN: string = "starkey";
  public AUDIBEL_SUB_DOMAIN: string = "audibel"; 
  public HEAR_CIRCLE_SUB_DOMAIN: string = "hearcircle"; 
  public SOUNDGEAR_SUB_DOMAIN: string = "soundgear"; 
  public KIND_SUB_DOMAIN: string = "kindilink3"; 
  public PHANTOM_SUB_DOMAIN: string = "phantom";
  public PHONESUPPORT_SUB_DOMAIN: string = "phonesupport";
  public TELEHEARPORTAL_SUB_DOMAIN: string = "telehearportal";

  // Caregiver Specific Sub Domains (For Delete Account Pages Only)
  public HEARSHARE_SUB_DOMAIN: string = "hearshare" // https://hearshare.telehearportal.com/HearShare/DeleteAccount
  public KINDILINK_ASSIST_SUB_DOMAIN: string = "kindilinkassist" // https://kindilinkassist.telehearportal.com/kindilinkAssist/DeleteAccount

  public MYSTARKEY_APP_NAME: string = "My Starkey";
  public MYAUDIBEL_APP_NAME: string = "My Audibel"; 
  public HEAR_CIRCLE_APP_NAME: string = "Hear Circle"; 
  public MYSOUNDGEAR_APP_NAME: string = "My SoundGear"; 
  public KINDILINK3_APP_NAME: string = "KINDiLink3"; 
  public THRIVE_APP_NAME: string = "Thrive Hearing Control";
  public MYPHANTOM_APP_NAME: string = "My Phantom";

  // Caregiver Apps
  public HEARSHARE_APP_NAME: string = "Hear Share";
  public KINDILINKASSIST_APP_NAME: string = "KINDiLink Assist";

  public PC_NOT_SUPPORTED: string;
  public PHONE_NOT_SUPPORTED: string;
  public PHONE_SUPPORTED: string;
  public PHONE_SUPPORTED_OS_UPDATE_REQUIRED: string;
  public PHONE_SUPPORTED_CANNOT_UPDATE_OS: string;
  public PHONE_SUPPORTED_STREAMING_NOT_AVAILABLE: string;
  public PHONE_SUPPORTED_TWO_WAY_AUDIO_CAPABLE: string;
  public PHONE_NOT_FULLY_TESTED: string;
  public PHONE_SUPPORTED_LIMITED_PERFORMANCE: string;
  public PHONE_SUPPORTED_UNABLE_TO_CONFIRM: string;

  public DEVICE_MAY_SUPPORT_TWO_WAY_AUDIO_MESSAGE: string;
  public DEVICE_MAY_SUPPORT_TWO_WAY_AUDIO_MESSAGE_TAP_HERE: string;
  public RECOMMENDED_DEVICES_LEARN_MORE_MESSAGE: string;

  public COMPATIBILITY_LINK_TEXT_WINDOWS: string;
  public COMPATIBILITY_LINK_TEXT_MAC: string;
  public COMPATIBILITY_STATEMENT_PC: string;
  public INCOMPATIBILITY_STATEMENT_PC: string;

  /* Download Statements */
  public GENESIS_DOWNLOAD_STATEMENT: string;
  public EVOLV_DOWNLOAD_STATEMENT: string;
  public INTRIGUE_DOWNLOAD_STATEMENT: string;
  public ARC_DOWNLOAD_STATEMENT: string;
  public HEAR_CIRCLE_DOWNLOAD_STATEMENT: string;
  public AMP_DOWNLOAD_STATEMENT: string;
  public CAREGIVER_DOWNLOAD_STATEMENT: string;
  public KIND_VARO_DOWNLOAD_STATEMENT: string;
  public KIND_VITALO_DOWNLOAD_STATEMENT: string;
  public KIND_ASSIST_DOWNLOAD_STATEMENT: string;

  public SUPPORTED_ICON_NAME: string;
  public UNRECOGNIZED_DEVICE_ICON_NAME: string;
  public UNSUPPORTED_ICON_NAME: string;
  public UNSUPPORTED_PC_ICON_NAME: string;
  public OS_UPDATE_OR_NO_STREAMING_ICON_NAME: string;

  /* App Links */  
  public CHINA_LINKS: string;
  public MYSTARKEY_LINK_ANDROID: string;
  public MYSTARKEY_LINK_IOS: string;
  public MYAUDIBEL_LINK_ANDROID: string;
  public MYAUDIBEL_LINK_IOS: string;
  public HEARCIRCLE_LINK_ANDROID: string;
  public HEARCIRCLE_LINK_IOS: string;
  public COMPATIBILITY_LINK_WINDOWS: string;
  public COMPATIBILITY_LINK_MAC: string

  // Load when KindILink3 becomes known
  public KINDILINK3_LINK_ANDROID: string;
  public KINDILINK3_LINK_IOS: string;
  public MYSOUNDGEAR_LINK_ANDROID: string;
  public MYSOUNDGEAR_LINK_IOS: string;
  public THRIVE_LINK_ANDROID: string;
  public THRIVE_LINK_IOS: string;
  public KINDILINK2_LINK_ANDROID: string;
  public KINDILINK2_LINK_IOS: string;
  public HEARSHARE_LINK_ANDROID: string;
  public HEARSHARE_LINK_IOS: string;
  public KINDILINK_ASSIST_LINK_ANDROID: string;
  public KINDILINK_ASSIST_LINK_IOS: string;

  // Banners
  public BANNER: string;
  public BANNER_DEVICE_COMPATIBILITY: string;
  public BANNER_COMPUTER_SUPPORT: string;
  public BANNER_DOWNLOAD_PAGE: string;

  public AID_TYPE_FORM_HEADER: string;
  public LEGACY_AID_TYPE_FORM_HEADER: string;
  public OR: string;
  public WEARING_GENESIS_AIDS: string;
  public WEARING_EVOLV_AIDS: string;
  public CAREGIVER: string;
  public CAREGIVER_AFTON: string;
  public WEARING_INTRIGUE_AIDS: string;
  public WEARING_ARC_AIDS: string;
  public WEARING_HEAR_CIRCLE_AIDS: string;
  public WEARING_AMP_AIDS: string;
  public WEARING_KIND_VARO_AIDS: string;
  public WEARING_KIND_VITALO_AIDS: string;
  public WEARING_SOUNDGEAR_AIDS: string;
  public WEARING_NXG_AI_AIDS: string;
  public WEARING_SAVANT_AI_AIDS: string;
  public WEARING_AFFLELOU_INCOGNITO_EDGE_AI_AIDS: string;
  public WEARING_OUIEZEN_SK_ED_AIDS: string;

  public TAP_HERE_STARKEY_COMPAT: string;
  public TAP_HERE_AUDIBEL_COMPAT: string;
  public TAP_HERE_HEAR_CIRCLE_COMPAT: string;
  public TAP_HERE_KIND_COMPAT: string;
  public TAP_HERE_SOUNDGEAR_COMPAT: string;

  /* Delete Account */
  public DELETE_ACCOUNT_HEADER_STARKEY: string;
  public DELETE_ACCOUNT_HEADER_AUDIBEL: string;
  public DELETE_ACCOUNT_HEADER_KIND3: string;
  public DELETE_ACCOUNT_HEADER_SOUNDGEAR: string;
  public DELETE_ACCOUNT_HEADER_PHANTOM: string;
  public DELETE_ACCOUNT_HEADER_HEAR_CIRCLE: string;
  public DELETE_ACCOUNT_HEADER_THRIVE: string;
  public DELETE_ACCOUNT_HEADER_KIND2: string;
  public DELETE_ACCOUNT_HEADER_IPROAI: string;
  public DELETE_ACCOUNT_HEADER_HEAR_SHARE: string;
  public DELETE_ACCOUNT_HEADER_KINDILINK_ASSIST: string;
  public TO_DELETE_ACCOUNT_BODY_STARKEY: string;
  public TO_DELETE_ACCOUNT_BODY_AUDIBEL: string;
  public TO_DELETE_ACCOUNT_BODY_KIND3: string;
  public TO_DELETE_ACCOUNT_BODY_SOUNDGEAR: string;
  public TO_DELETE_ACCOUNT_BODY_PHANTOM: string;
  public TO_DELETE_ACCOUNT_BODY_HEAR_CIRCLE: string;
  public TO_DELETE_ACCOUNT_BODY_THRIVE: string;
  public TO_DELETE_ACCOUNT_BODY_KIND2: string;
  public TO_DELETE_ACCOUNT_BODY_IPROAI: string;
  public TO_DELETE_ACCOUNT_BODY_HEAR_SHARE: string;
  public TO_DELETE_ACCOUNT_BODY_KINDILINK_ASSIST: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_STARKEY: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_AUDIBEL: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_KIND3: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_SOUNDGEAR: string;  
  public EMAIL_TO_CONFIRM_DELETION_BODY_PHANTOM: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_HEAR_CIRCLE: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_THRIVE: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_KIND2: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_IPROAI: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_HEAR_SHARE: string;
  public EMAIL_TO_CONFIRM_DELETION_BODY_KINDILINK_ASSIST: string;
  public EMAIL_CONFIRMATION_CHECK_EMAIL: string;
  public EMAIL_CONFIRMATION_SENT: string;
  public DATA_REMOVED_BODY: string;
  public CONTINUE_BUTTON: string;
  public EMAIL_INPUT: string;
  public INVALID_EMAIL_ADDRESS: string;

  public userLang: string;
  public brand: string = "";

  private account_deletion_email = "";

  constructor(private readonly browser: BrowserPlatformService) {
    this.userLang = this.browser.navigator.language.toLowerCase().replace('_', '-');
    const partialUserLang = this.userLang.split("-")[0]

    const translationMap = new Map(Object.entries(Translations));
    const fullLanguageCodes = Object.keys(Translations)
    const partialLanguageCodes = fullLanguageCodes.map(val => val.split("-")[0])
    
    let translation;

    if(fullLanguageCodes.includes(this.userLang)) { // exact language code is in CAT JSON
      translation = translationMap.get(this.userLang)
    }
    else if(partialLanguageCodes.includes(partialUserLang)) { // partial (before "-") language code is in partial code CAT JSON
      if(fullLanguageCodes.includes(partialUserLang)) { // partial language code is in full CAT JSON e.g. "de"
        translation = translationMap.get(partialUserLang)
      }
      else {  // partial language code is not in full code CAT JSON e.g. "zh"
        let fullLanguageCode = 'default';
        fullLanguageCodes.forEach(code => {
          if(code.includes(partialUserLang)) {
            fullLanguageCode = code;
          }
        })
        translation = translationMap.get(fullLanguageCode)
      }
    }
    else {  // default to "en"
      translation = translationMap.get("en")
    }

    /* Compatability Statements */
    this.PHONE_NOT_SUPPORTED = translation!.not_recognized;
    this.PHONE_SUPPORTED = translation!.supported;
    this.PHONE_SUPPORTED_OS_UPDATE_REQUIRED = translation!.os_updated_required;
    this.PHONE_SUPPORTED_CANNOT_UPDATE_OS = translation!.supported_cannot_update_os;
    this.PHONE_SUPPORTED_STREAMING_NOT_AVAILABLE = translation!.streaming_not_available;
    this.PHONE_SUPPORTED_TWO_WAY_AUDIO_CAPABLE = translation!.supported_two_way;
    this.PHONE_NOT_FULLY_TESTED = translation!.not_tested;
    this.PHONE_SUPPORTED_LIMITED_PERFORMANCE = translation!.limited_performance_phone_support;
    this.PHONE_SUPPORTED_UNABLE_TO_CONFIRM = translation!.unable_to_confirm_phone_support;

    /* PC Compatibility Statements */
    this.PC_NOT_SUPPORTED = translation!.pc_not_supported;
    this.COMPATIBILITY_LINK_TEXT_WINDOWS = translation!.compatibility_link_text_windows;
    this.COMPATIBILITY_LINK_TEXT_MAC = translation!.compatibility_link_text_mac;
    this.COMPATIBILITY_STATEMENT_PC = translation!.compatiblity_statement_pc;
    this.INCOMPATIBILITY_STATEMENT_PC = translation!.incompatibility_statement_pc;

    /* Device May Support Two Way Audio Statements */
    this.DEVICE_MAY_SUPPORT_TWO_WAY_AUDIO_MESSAGE = translation!.device_may_support_two_way_audio_message;
    this.DEVICE_MAY_SUPPORT_TWO_WAY_AUDIO_MESSAGE_TAP_HERE = translation!.device_may_support_two_way_audio_message_tap_here;
    this.RECOMMENDED_DEVICES_LEARN_MORE_MESSAGE = translation!.recommended_devices_learn_more_message;

    /* Download Statements - Starkey */
    this.GENESIS_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.my_starkey)
    this.EVOLV_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.thrive)

    /* Download Statements - Audibel */
    this.INTRIGUE_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.my_audibel)
    this.ARC_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.thrive)

    /* Download Statement - Hear Circle */
    this.HEAR_CIRCLE_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.hear_circle)
    
    /* Download Statement - Sound Gear */
    this.AMP_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.my_sound_gear)

    /* Download Statements - KIND */
    this.KIND_VARO_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.kindilink3)
    this.KIND_VITALO_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.kindilink2)
 
    /* Download Statements - Caregiver (third option) */
    this.CAREGIVER_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.hear_share)
    this.KIND_ASSIST_DOWNLOAD_STATEMENT = translation!.download_app.replace("{0}", translation!.kindilink_assist)

    /* Banner */
    this.BANNER = translation!.banner
    this.BANNER_DEVICE_COMPATIBILITY = translation!.banner_device_compatibility;
    this.BANNER_COMPUTER_SUPPORT = translation!.banner_computer_support;
    this.BANNER_DOWNLOAD_PAGE = translation!.banner_download_page;

    /* Aid Type Form */
    this.AID_TYPE_FORM_HEADER = translation!.aid_type_form_header;
    this.LEGACY_AID_TYPE_FORM_HEADER = translation!.header;
    this.OR = translation!.or;
    this.WEARING_GENESIS_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.starkey_genesis + "</b>")
    this.WEARING_EVOLV_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.starkey_evolv + "</b>")
    this.CAREGIVER = translation!.caregiver;
    this.CAREGIVER_AFTON = translation!.caregiver_afton;
    this.WEARING_INTRIGUE_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.audibel_intrigue + "</b>")
    this.WEARING_ARC_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.audibel_arc + "</b>")
    this.WEARING_HEAR_CIRCLE_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.hear_circle + "</b>")
    this.WEARING_KIND_VARO_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.kind_varo + "</b>")
    this.WEARING_KIND_VITALO_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.kind_vitalo + "</b>")
    //this.WEARING_SOUNDGEAR_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.soundgear_amp + "</b>")
    this.WEARING_SOUNDGEAR_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.kind_varo + "</b>");
    this.WEARING_NXG_AI_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + "NXG AI" + "</b>");
    this.WEARING_SAVANT_AI_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + "Savant AI" + "</b>");
    this.WEARING_AMP_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.soundgear_amp + "</b>");

    this.WEARING_AFFLELOU_INCOGNITO_EDGE_AI_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.afflelou_incognito_edge_ai + "</b>");
    this.WEARING_OUIEZEN_SK_ED_AIDS = translation!.wearing_hearing_aids.replace("{0}", "<b>" + translation!.ouiezen_SK_ED + "</b>");

    this.TAP_HERE_STARKEY_COMPAT = translation!.compatibility_list.replace("{0}", `<a href='https://www.starkey.com/hearing-aids/apps' target="_blank" rel="noopener noreferrer">${translation!.tap_here}</a>`)
    this.TAP_HERE_AUDIBEL_COMPAT = translation!.compatibility_list.replace("{0}", `<a href='https://www.audibel.com' target="_blank" rel="noopener noreferrer">${translation!.tap_here}</a>`)
    // TODO: Change to HearCircle link
    this.TAP_HERE_HEAR_CIRCLE_COMPAT = translation!.compatibility_list.replace("{0}", `<a href='https://www.nuear.com/' target="_blank" rel="noopener noreferrer">${translation!.tap_here}</a>`)
    this.TAP_HERE_KIND_COMPAT = translation!.compatibility_list.replace("{0}", `<a href='https://www.kind.com' target="_blank" rel="noopener noreferrer">${translation!.tap_here}</a>`)
    this.TAP_HERE_SOUNDGEAR_COMPAT = translation!.compatibility_list.replace("{0}", `<a href='https://www.soundgear.com' target="_blank" rel="noopener noreferrer">${translation!.tap_here}</a>`)
 
    /* Delete Account Statements - Starkey */
    this.DELETE_ACCOUNT_HEADER_STARKEY = translation!.delete_account_header.replace("{0}", translation!.my_starkey)
    this.TO_DELETE_ACCOUNT_BODY_STARKEY = translation!.to_delete_account_body.replace("{0}", translation!.my_starkey)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_STARKEY = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.my_starkey)
    this.DATA_REMOVED_BODY = translation!.data_removed_body
    this.CONTINUE_BUTTON = translation!.continue_button
    this.EMAIL_INPUT = translation!.email_input
    
    /* Delete Account Statements - Audibel */
    this.DELETE_ACCOUNT_HEADER_AUDIBEL = translation!.delete_account_header.replace("{0}", translation!.my_audibel)
    this.TO_DELETE_ACCOUNT_BODY_AUDIBEL = translation!.to_delete_account_body.replace("{0}", translation!.my_audibel)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_AUDIBEL = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.my_audibel )

    /* Delete Account Statements - KindiLink3 */
    this.DELETE_ACCOUNT_HEADER_KIND3 = translation!.delete_account_header.replace("{0}", translation!.kindilink3)
    this.TO_DELETE_ACCOUNT_BODY_KIND3 = translation!.to_delete_account_body.replace("{0}", translation!.kindilink3)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_KIND3 = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.kindilink3 )

    /* Delete Account Statements - SoundGear */
    this.DELETE_ACCOUNT_HEADER_SOUNDGEAR = translation!.delete_account_header.replace("{0}", translation!.my_sound_gear)
    this.TO_DELETE_ACCOUNT_BODY_SOUNDGEAR = translation!.to_delete_account_body.replace("{0}", translation!.my_sound_gear)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_SOUNDGEAR = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.my_sound_gear)

    /* Delete Account Statements - MyPhantom */
    this.DELETE_ACCOUNT_HEADER_PHANTOM = translation!.delete_account_header.replace("{0}", translation!.my_phantom)
    this.TO_DELETE_ACCOUNT_BODY_PHANTOM = translation!.to_delete_account_body.replace("{0}", translation!.my_phantom)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_PHANTOM = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.my_phantom)

    /* Delete Account Statements - Hear Circle */
    this.DELETE_ACCOUNT_HEADER_HEAR_CIRCLE = translation!.delete_account_header.replace("{0}", translation!.hear_circle)
    this.TO_DELETE_ACCOUNT_BODY_HEAR_CIRCLE = translation!.to_delete_account_body.replace("{0}", translation!.hear_circle)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_HEAR_CIRCLE = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.hear_circle)
    
    /* Delete Account Statements - Thrive */
    this.DELETE_ACCOUNT_HEADER_THRIVE = translation!.delete_account_header.replace("{0}", translation!.thrive)
    this.TO_DELETE_ACCOUNT_BODY_THRIVE = translation!.to_delete_account_body.replace("{0}", translation!.thrive)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_THRIVE = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.thrive)

    /* Delete Account Statements - KindiLink2 */
    this.DELETE_ACCOUNT_HEADER_KIND2 = translation!.delete_account_header.replace("{0}", translation!.kindilink2)
    this.TO_DELETE_ACCOUNT_BODY_KIND2  = translation!.to_delete_account_body.replace("{0}", translation!.kindilink2)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_KIND2 = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.kindilink2)

     /* Delete Account Statements - iProAI */
     this.DELETE_ACCOUNT_HEADER_IPROAI = translation!.delete_account_header.replace("{0}", "iProAI")
     this.TO_DELETE_ACCOUNT_BODY_IPROAI  = translation!.to_delete_account_body.replace("{0}", "iProAI")
     this.EMAIL_TO_CONFIRM_DELETION_BODY_IPROAI = translation!.email_to_confirm_deletion_body.replace("{0}", "iProAI")

    /* Delete Account Statements - HearShare */
    this.DELETE_ACCOUNT_HEADER_HEAR_SHARE = translation!.delete_account_header.replace("{0}", translation!.hear_share)
    this.TO_DELETE_ACCOUNT_BODY_HEAR_SHARE = translation!.to_delete_account_body.replace("{0}", translation!.hear_share)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_HEAR_SHARE = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.hear_share)

    /* Delete Account Statements - KINDiLink Assist */
    this.DELETE_ACCOUNT_HEADER_KINDILINK_ASSIST = translation!.delete_account_header.replace("{0}", translation!.kindilink_assist)
    this.TO_DELETE_ACCOUNT_BODY_KINDILINK_ASSIST = translation!.to_delete_account_body.replace("{0}", translation!.kindilink_assist)
    this.EMAIL_TO_CONFIRM_DELETION_BODY_KINDILINK_ASSIST = translation!.email_to_confirm_deletion_body.replace("{0}", translation!.kindilink_assist)

    this.INVALID_EMAIL_ADDRESS = translation!.no_account_exists_for_email;

    // TODO: Add Delete Account Statements for other brands

    /* Delete Account Confirmation Statements */
    this.EMAIL_CONFIRMATION_CHECK_EMAIL = translation!.sent_check_email;
    this.EMAIL_CONFIRMATION_SENT = translation!.sent_confirmation;

    /* Icon File Names (located in /assets/icons) */
    this.SUPPORTED_ICON_NAME = "Supported"
    this.UNRECOGNIZED_DEVICE_ICON_NAME = "UnrecognizedDevice"
    this.UNSUPPORTED_ICON_NAME = "Unsupported"
    this.UNSUPPORTED_PC_ICON_NAME = "UnsupportedPC"
    this.OS_UPDATE_OR_NO_STREAMING_ICON_NAME = "OSUpgradeOrNoStreaming"

    /* App Links */   
    
    this.CHINA_LINKS = "https://www.starkey.com.cn/download.html"

    this.MYSTARKEY_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.mystarkey.release"
    this.MYSTARKEY_LINK_IOS = "https://apps.apple.com/us/app/my-starkey/id1549559068"
    this.MYSTARKEY_LINK_IOS = "https://apps.apple.com/us/app/my-starkey/id1549559068"

    this.MYAUDIBEL_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.myaudibel.release"
    this.MYAUDIBEL_LINK_IOS = "https://apps.apple.com/us/app/my-audibel/id1591088472"

    this.HEARCIRCLE_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.hearcircle.release"
    this.HEARCIRCLE_LINK_IOS = "https://apps.apple.com/us/app/hear-circle/id6449471168"

    this.KINDILINK3_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.engagekind.release"
    this.KINDILINK3_LINK_IOS = "https://apps.apple.com/de/app/kindilink3/id6449471031"

    this.MYSOUNDGEAR_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.soundgear.release"
    this.MYSOUNDGEAR_LINK_IOS = "https://apps.apple.com/us/app/my-soundgear/id6473621210"

    this.THRIVE_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.android.newlink.release"
    this.THRIVE_LINK_IOS = "https://apps.apple.com/us/app/thrive-hearing-control/id1322659659"

    this.KINDILINK2_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.android.kind.release&pli=1"
    this.KINDILINK2_LINK_IOS = "https://apps.apple.com/de/app/kindilink2/id1451639026"    

    this.HEARSHARE_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.caregiver.release"
    this.HEARSHARE_LINK_IOS = "https://apps.apple.com/us/app/hear-share/id1483221109"
    
    this.KINDILINK_ASSIST_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.starkey.caregiver.kind.release"
    this.KINDILINK_ASSIST_LINK_IOS = "https://apps.apple.com/lu/app/kindilink-assist/id1498988880"

    this.COMPATIBILITY_LINK_WINDOWS = "https://support.microsoft.com/en-us/windows/check-if-your-windows-11-pc-supports-bluetooth-low-energy-audio-2b79c085-0353-4467-8306-ebb2657a91de";
    this.COMPATIBILITY_LINK_MAC = "https://support.apple.com/en-us/106341";
  }

  public setAccountDeletionEmail(email: string) {
    this.account_deletion_email = email;
  }

  public getAccountDeletionEmail():string {
    return this.account_deletion_email;
  }

  public createNewCompatibilityResultDataObject(): CompatibilityResultData {
    return {
      compatibilityStatement: "",
      iconFileName: ""
    }
  }

  public deviceNotSupported(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_NOT_SUPPORTED,
      iconFileName: this.UNSUPPORTED_ICON_NAME
    }
  }

  public deviceSupported(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_SUPPORTED,
      iconFileName: this.SUPPORTED_ICON_NAME
    }
  }

  public deviceOSUpdateRequired(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_SUPPORTED_OS_UPDATE_REQUIRED,
      iconFileName: this.OS_UPDATE_OR_NO_STREAMING_ICON_NAME
    }
  }

  public deviceSupportedStreamingNotAvailable(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_SUPPORTED_STREAMING_NOT_AVAILABLE,
      iconFileName: this.OS_UPDATE_OR_NO_STREAMING_ICON_NAME
    }
  }

  public deviceSupportedButCannotUpdateOS(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_SUPPORTED,
      iconFileName: this.OS_UPDATE_OR_NO_STREAMING_ICON_NAME
    }
  }

  public deviceNotFullyTested(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_NOT_FULLY_TESTED,
      iconFileName: this.UNRECOGNIZED_DEVICE_ICON_NAME
    }
  }

  public deviceSupportedTwoWayAudioCapable(): CompatibilityResultData {
    return {
      compatibilityStatement: this.PHONE_SUPPORTED_TWO_WAY_AUDIO_CAPABLE,
      iconFileName: this.SUPPORTED_ICON_NAME
    }
  }

  public setSiteBrand(brand: string) {
    this.brand = brand;
  }

  public getSiteBrand(): string {

    if(this.brand !== "" && this.brand !== undefined && this.brand !== null) {
      return this.brand;
    }
    if(this.browser.sessionStorage.getItem('brand') && this.browser.sessionStorage.getItem('brand') !== 'undefined') {
      return this.browser.sessionStorage.getItem('brand') ?? "starkey";
    }
    if(this.browser.location.pathname === "/nuear") {
      return "nuear"
    }
    if(this.browser.location.pathname === "/audiosync") {
      return "audiosync"
    }
    
    const [subdomain = '', domain = ''] = this.browser.location.hostname.split('.');
    //console.log("BRAND ARRAY", brand); 
    if(subdomain.includes(this.PHONESUPPORT_SUB_DOMAIN)) {
        return domain || environment.defaultBrand || 'starkey'
      }
    else if (domain.includes(this.TELEHEARPORTAL_SUB_DOMAIN)) {
      const brandEnvironment = subdomain.split('-');
      return brandEnvironment[0]
    }
    else {
        return environment.defaultBrand || subdomain || 'starkey'
      }
  }
}
